import moment from "moment"
import Product from "@/models/Product"
import OrderItem from "@/models/OrderItem"
import Contact from "@/models/Contact";
import Location from "@/models/Location";

export default class BillOfLadingBuilder {

  constructor() {
    this._attributes = {
        seal_number: null,
        order_number: null,
        po_number: null,
        date_ordered: null,
        date_shipped: null,
        sold_to_location: {
            name: null,
            street_address: null,
            city: null,
            region: null,
            country: null
        },
        sold_to_contact: {
            name: null,
            phone: null
        },
        ship_to_locations: [],
        ship_to_contacts: [],
        carrier: null,
        trailer: null,
        contact_name: null,
        contact_number: null,
        contact_email: null,
        items: [],
    };

    var bindAccessors = function(obj,p,properties)
    {
      var _p = p.split('_').map(i=>i.split('').map((j,k)=>(k===0?j.toUpperCase():j)).join('')).join('');
      obj["get"+_p]=function() { return properties[p]; }
      obj["set"+_p]=function(val) { properties[p]=val; return this; }
    };
    for (var p in this._attributes)
      bindAccessors(this, p, this._attributes);

  }

  addSoldToLocation(name, street_address, city, region, country) {
    var l = {name, street_address, city, region, country};
    for(var i in l) {
      this._attributes.sold_to_location[i] = l[i];
    }
  }

  addShipToLocation(drop, name, street_address, city, region, country) {
    this._attributes.ship_to_locations.push({
      drop, name, street_address, city, region, country
    });
  }

  addSoldToContact(name, phone) {
    var l = {name, phone};
    for(var i in l) {
      this._attributes.sold_to_contact[i] = l[i];
    }
  }

  addShipToContact(drop, name, phone) {
    this._attributes.ship_to_contacts.push({
      drop, name, phone
    });
  }

  addItem(drop, quantity, code, description) {
    this._attributes.items.push({
      drop, quantity, code, description
    });
  }

  setCustomer(name, phone, email)
  {
    this.contact_name = name;
    this.contact_number = phone;
    this.contact_email = email;
  }

  parseOrderEntity(order) {
    this.setOrderNumber(order.number);
    this.setPoNumber(order.po_number);
    this.setCustomer(order.contact_name, order.contact_number, order.contact_email);
    let earliest_time = null;
    let earliest = null;
    let scheduled = null;
    order.order_status_logs.forEach((log) => {
      let temp = moment(log.created_at);
      if(!earliest) {
        earliest = log;
        earliest_time = temp;
      } else if(temp.diff(earliest_time) > 0) {
        earliest = log;
        earliest_time = temp;
      }
      if(log.order_status && log.order_status.name === 'Scheduled') {
        scheduled = log;
      }
    });
    this.setDateOrdered(earliest ? earliest.created_at : null);
    this.setDateShipped(scheduled ? scheduled.created_at : null);

    let valid_drops = [];
    order.order_items.forEach((item) => {
      if(item.drop) {
        valid_drops.push(+(item.drop));
      }
      this.addItem(item.drop, item.quantity, (item.product ? item.product.number : null), item.getFilteredName());
    });

    let primary_drop_contact = null;
    order.order_contacts.forEach((order_contact) => {
      if(order_contact.drop && valid_drops.includes(+(order_contact.drop))) {
        var contact = order_contact.contact;
        this.addShipToContact(order_contact.drop, contact.full_name, contact.phone);
        if(+(order_contact.drop) === 1) {
          primary_drop_contact = contact;
        }
      }
    });

    let primary_drop_location = null;
    order.order_locations.forEach((order_location) => {
      if(order_location.drop && valid_drops.includes(+(order_location.drop))) {
        var location = order_location.location;
        this.addShipToLocation(order_location.drop, null, location.street_address, location.city, location.region, location.country);
        if(+(order_location.drop) === 1) {
          primary_drop_location = location;
        }
      }
    });

    let billing_contact = null;
    if(!billing_contact) {
      billing_contact = primary_drop_contact;
    }
    if(billing_contact) {
      this.addSoldToContact(billing_contact.full_name, billing_contact.phone);
    }

    let billing_address = null;
    if(!billing_address) {
      billing_address = primary_drop_location;
    }
    if(billing_address) {
      this.addSoldToLocation(order.customer.name, billing_address.street_address, billing_address.city, billing_address.region, billing_address.country);
    }

    this.setCarrier(order.carrier ? order.carrier.name : null);
  }
  
  getCustomerContact()
  {
    return this.contact_name?this.contact_name+" "+this.contact_number:"";
  }

  parseOrderCommitEntity(commit, customer) {

    let order = commit.data.order;

    this.setOrderNumber(order.number);
    this.setPoNumber(order.po_number);
    this.setDateOrdered(moment().format('L'));
    this.setDateShipped(order.estimated_date);
    this.setCustomer(order.contact_name, order.contact_number, order.contact_email);
    let valid_drops = [];
    commit.data.order_items.forEach((item) => {
      if(item.drop) {
        valid_drops.push(+(item.drop));
      }
      let product = Product.find(item.product_id);
      this.addItem(item.drop, item.quantity, (product ? product.number : null), OrderItem.parseFilteredName(product, 
        [item.insulation_cut.width, item.insulation_cut.thickness, item.insulation_cut.length].filter(l=>!!l).length !== 0 ? item.insulation_cut : null, item.description));
    });

    let primary_drop_contact = null;
    let order_contacts = commit.data.order_contacts;
    if(!Array.isArray(order_contacts)) {
      order_contacts = Object.keys(order_contacts).map(k=>order_contacts[k]);
    }
    order_contacts.forEach((contact_id, i) => {
      let drop = i+1;
      if(contact_id && drop && valid_drops.includes(+(drop))) {
        var contact = Contact.find(contact_id);
        if(contact) {
          this.addShipToContact(drop, contact.full_name, contact.phone);
          if(+(drop) === 1) {
            primary_drop_contact = contact;
          }
        }
      }
    });

    let primary_drop_location = null;
    let order_locations = commit.data.order_locations;
    if(!Array.isArray(order_locations)) {
      order_locations = Object.keys(order_locations).map(k=>order_locations[k]);
    }
    order_locations.forEach((location_id, i) => {
      let drop = i+1;
      if(location_id && drop && valid_drops.includes(+(drop))) {
        var location = Location.find(location_id);
        if(location) {
          this.addShipToLocation(drop, null, location.street_address, location.city, location.region, location.country);
          if(+(drop) === 1) {
            primary_drop_location = location;
          }
        }
      }
    });

    let billing_contact = null;
    if(!billing_contact) {
      billing_contact = primary_drop_contact;
    }
    if(billing_contact) {
      this.addSoldToContact(billing_contact.full_name, billing_contact.phone);
    }

    let billing_address = null;
    if(!billing_address) {
      billing_address = primary_drop_location;
    }
    if(billing_address) {
      this.addSoldToLocation((customer ? customer.name : null), billing_address.street_address, billing_address.city, billing_address.region, billing_address.country);
    }

  }
  
}